<template>
  <div class="mt-3">
    <div class="d-flex justify-end align-center mt-4">
      <input-checkbox
        v-model="flagSistema"
        class="mr-5 font-weight-bold"
        :label="
          $t('modulos.formula.formulas_derivadas.apresentar_formulas_sistema')
        "
      />
      <botao-padrao v-if="!visualizar" @click="abrirModalNovaFormulaDerivada">
        <v-icon>$mdiPlusThick</v-icon>
        {{ $t('modulos.formula.formulas_derivadas.botao_nova_formula') }}
      </botao-padrao>
    </div>
    <div class="quantidade ml-2">
      {{
        $tc('componentes.cabecalho_pagina.registros', tabela.dados?.length, {
          count: dadosFiltrados?.length,
        })
      }}
    </div>
    <botao-padrao
      v-if="podeExcluir && buscarPermissao('Formula', 'Deletar')"
      class="my-2"
      outlined
      color="danger"
      @click="excluirRegistros"
    >
      <v-icon>$mdiTrashCanOutline</v-icon>
      {{ $t('geral.botoes.excluir') }}
    </botao-padrao>
    <tabela-padrao-prime-vue
      v-model="tabela.selecionados"
      :dados="dadosFiltrados"
      :colunas="tabela.colunas"
      class="mt-4"
      :mostrar-seletor="buscarPermissao('Formula', 'Deletar') && !visualizar"
      ajustar-altura-linha
      filtro-geral
      :quantidade-itens="tabela.dados?.length"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina-atual="tabela.paginaAtual"
      paginacao-em-memoria
      sem-paginacao
      mostrar-acoes
      :filters="filters"
      :global-filters="tabela.colunas.map((c) => c.value)"
    >
      <template v-slot:acoes="{ slotProps }">
        <dropdown-padrao text color="secondary">
          <template #botao>
            <v-icon> $dotsVertical </v-icon>
          </template>
          <dropdown-padrao-item
            v-if="
              !visualizar &&
              !slotProps.data.flagSistema &&
              buscarPermissao('Formula', 'Editar')
            "
            @click="abrirEditar(slotProps.data)"
          >
            {{ $t('geral.botoes.editar') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            v-if="
              !visualizar &&
              !slotProps.data.flagSistema &&
              buscarPermissao('Formula', 'Duplicar')
            "
            @click="duplicarItem(slotProps.data)"
          >
            {{ $t('geral.botoes.duplicar') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            v-if="buscarPermissao('Formula', 'Visualizar')"
            @click="visualizarDerivada(slotProps.data)"
          >
            {{ $t('geral.botoes.visualizar') }}
          </dropdown-padrao-item>
        </dropdown-padrao>
      </template>
    </tabela-padrao-prime-vue>
    <formula-derivada-modal
      ref="modal-formula-derivada"
      :form-mensurando="form"
      :unidade-medida-id="unidadeMedidaId"
      :revisao-formula-derivada-id="revisaoFormulaId"
      @atualizar-dados="buscarDerivadas"
    />
    <template>
      <novo-simbolo-duplicar-modal
        ref="novo-simbolo-duplicar-modal"
        @atualizar-formulas="buscarDerivadas"
      />
    </template>
  </div>
</template>
<script>
import FormulaService from '@/common/services/cadastros/FormulaService.js';
import FormulaDerivadaModal from './modais/FormulaDerivadaModal.vue';
import NovoSimboloDuplicarModal from './modais/NovoSimboloDuplicarModal.vue';
import { FilterMatchMode } from 'primevue/api';
import { DropdownModel } from '@common/models/geral/DropdownModel';
import helpers from '@/common/utils/helpers';

export default {
  components: {
    FormulaDerivadaModal,
    NovoSimboloDuplicarModal,
  },
  props: {
    form: { type: Object, required: true },
    revisaoFormulaId: { type: String, default: '' },
  },
  data() {
    return {
      flagSistema: false,
      visualizar: false,
      unidadeMedidaId: {},
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.formula.formulas_derivadas.tabela.codigo'),
            sortable: true,
          },
          {
            value: 'simbolo',
            text: this.$t('modulos.formula.formulas_derivadas.tabela.simbolo'),
            sortable: true,
          },
          {
            value: 'nome',
            text: this.$t('modulos.formula.formulas_derivadas.tabela.mome'),
            sortable: false,
          },
        ],
      },
    };
  },
  computed: {
    podeExcluir() {
      return this.tabela.selecionados.length > 0;
    },
    dadosFiltrados() {
      return this.flagSistema
        ? this.tabela.dados
        : this.tabela.dados.filter((item) => !item.flagSistema);
    },
  },
  mounted() {
    this.buscarDerivadas();
    if (
      this.$route.name == 'formula-visualizar' ||
      this.$route.name == 'formula-revisoes-visualizar'
    ) {
      this.visualizar = true;
    }
    this.tabela.dados = this.form.derivadas
      .filter((item) => item.id !== this.form.id)
      .map((item) => {
        return {
          ...item,
          unidadeMedida: {
            text: item.unidadeMedida.nome,
            value: item.unidadeMedida.id,
          },
        };
      });
  },
  methods: {
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    async abrirEditar(item) {
      if (item.imagem && item.nomeArquivoImagem) {
        let ctx = { ...item, fileImagem: null };
        await helpers
          .converterBase64ParaFile(
            item.imagem,
            item.nomeArquivoImagem,
            'image/png'
          )
          .then(function (file) {
            ctx.fileImagem = file;
            delete ctx.imagem;
            delete ctx.nomeArquivoImagem;
            item = ctx;
          });
      }
      this.$refs['modal-formula-derivada'].abrirModal(item, false, true);
    },
    duplicarItem(item) {
      if (!item.flagSistema && !item.mensurando) {
        this.$refs['novo-simbolo-duplicar-modal'].abrirModal(this.form, item);
        return;
      }

      this.$store.dispatch('Layout/iniciarCarregamento');
      if (item.id) {
        FormulaService.duplicarDerivada(this.form.id, item.id)
          .then(() => {
            this.buscarDerivadas();
            this.toastSucesso(this.$t(`modulos.formula.duplicada_sucesso`));
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      }
    },
    async visualizarDerivada(item) {
      if (item.imagem && item.nomeArquivoImagem) {
        let ctx = { ...item, fileImagem: null };
        await helpers
          .converterBase64ParaFile(
            item.imagem,
            item.nomeArquivoImagem,
            'image/png'
          )
          .then(function (file) {
            ctx.fileImagem = file;
            delete ctx.imagem;
            delete ctx.nomeArquivoImagem;
            item = ctx;
          });
      }
      this.$refs['modal-formula-derivada'].abrirModal(item, true, true);
    },
    excluirRegistros() {
      const itensNaoExcluiveis = this.tabela.selecionados.filter(
        (item) => item.flagSistema
      );
      if (itensNaoExcluiveis.length > 0) {
        this.toastErro(this.$t('modulos.formula.erro_exclusao_flag_sistema'));
        return;
      }
      this.confirmarExcluir().then(() => {
        this.$store.dispatch('Layout/iniciarCarregamento');
        FormulaService.excluirDerivada(
          this.form.id,
          this.tabela.selecionados[0].id
        )
          .then(() => {
            this.buscarDerivadas();
            this.toastSucesso(this.$t(`modulos.formula.exclusao_sucesso`));
            this.tabela.selecionados = [];
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      });
    },
    buscarDerivadas() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      FormulaService.buscar(this.form.id)
        .then((res) => {
          this.unidadeMedidaId = new DropdownModel(res.data.unidadeMedida);
          this.tabela.dados = res.data.derivadas;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.formula.erros.id_invalido'));
        })
        .finally(() => {
          this.$emit('dados-alterados');
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    abrirModalNovaFormulaDerivada() {
      this.$refs['modal-formula-derivada'].abrirModal();
    },
  },
};
</script>
<style lang="scss">
.quantidade {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.v-application .mt-4 {
  margin-top: 0px !important;
}
</style>
